import React, { useState } from 'react';
import { downloadReport } from '../../core/api/reports';

const Reports = () => {
  const [formData, setFormData] = useState({
    startDate: '',
    endDate: '',
    transactionType: '',
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  const handleDownloadStatements = async () => {
    setLoading(true);
    setError(null);
    try {
      const { transactionType, startDate, endDate } = formData;
      await downloadReport(transactionType, startDate, endDate);
      console.log('Report downloaded successfully');
    } catch (error) {
      console.error(error);
      setError('Failed to download report');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="container-fluid p-5">
          <h2 className="text-center mb-4">Download Reports in PDF</h2>
          <form>
            <div className="row mb-3">
              <div className="col-lg-4 col-12">
                <label htmlFor="startDate" className="form-label">
                  Start Date:
                </label>
                <input
                  type="date"
                  id="startDate"
                  name="startDate"
                  className="form-control"
                  value={formData.startDate}
                  onChange={handleInputChange}
                />
              </div>
              <div className="col-lg-4 col-12">
                <label htmlFor="endDate" className="form-label">
                  End Date:
                </label>
                <input
                  type="date"
                  id="endDate"
                  name="endDate"
                  className="form-control"
                  value={formData.endDate}
                  onChange={handleInputChange}
                />
              </div>
              <div className="col-lg-4 col-12">
                <label htmlFor="transactionType" className="form-label">
                  Report Type:
                </label>
                <select
                  id="transactionType"
                  name="transactionType"
                  className="form-select"
                  value={formData.transactionType}
                  onChange={handleInputChange}
                >
                  <option value="">Select Report Type</option>
                  <option value="employees">Employees</option>
                  <option value="patients">Patients</option>
                  <option value="appointments">Appointments</option>
                </select>
              </div>
            </div>

            <div className="text-center mt-4">
              <button
                type="button"
                className="btn btn-primary btn-lg"
                onClick={handleDownloadStatements}
                disabled={!formData.endDate || !formData.startDate || !formData.transactionType || loading}
              >
                {loading ? "Loading...." : 'Download Report'}
              </button>
              {error && <p className="text-danger mt-3">{error}</p>}
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Reports;